var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',_vm._b({attrs:{"item-text":"text","item-value":"value","items":_vm.items,"value":_vm.value},on:{"change":function($event){return _vm.$emit('change', $event)}}},'v-select',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }